import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Dialog } from '../../../../../components/ui';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';
import { isStaticBuilderField } from '../../utils/formStudioFormUtils';

export default function FormPreviewDialog({ open, onClose, fields = [] }) {
  const { typographyStyles, semantic } = useFeatureTheme();
  const previewFields = fields.filter((field) => !isStaticBuilderField(field));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Form preview"
      maxWidth="sm"
      fullWidth
    >
      {previewFields.length === 0 ? (
        <Typography sx={{ color: semantic.text.muted }}>No fields to preview.</Typography>
      ) : (
        <Grid container spacing={2}>
          {previewFields.map((field) => (
            <Grid item xs={12} key={field.item_id ?? field.key_name}>
              <Typography sx={{ ...typographyStyles.bodyText, fontWeight: 600, mb: 0.5 }}>
                {field.alias_name || field.key_name} ({field.key_type})
              </Typography>
              <TextField
                size="small"
                fullWidth
                disabled
                placeholder={`Example ${String(field.key_type || '').toLowerCase()} input`}
              />
            </Grid>
          ))}
        </Grid>
      )}
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Typography sx={{ ...typographyStyles.caption, color: semantic.text.muted }}>
          Preview is read-only and does not submit data.
        </Typography>
      </Box>
    </Dialog>
  );
}
